const DEVICE_ID_KEY = "vantapulse_device_id";

function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// Identifiant persistant par navigateur (indépendant de l'IP, qui change en
// 4G/5G ou en changeant de wifi) : permet de reconnaître "le même appareil"
// dans Paramètres > Sécurité > Appareils connectés même quand l'IP diffère
// d'une connexion à l'autre.
export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = generateId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return generateId();
  }
}
